import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { baseUrl } from '../nametitle/dataUrl';
import axios from 'axios';
import { valueLocal } from '../nametitle/localValue';
import { Spinner } from 'react-bootstrap';

const DonationCheckoutPage = () => {


    // information sur les state
    const imageDonation = "donationcheckout.png";

    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        countryCode: '225',
        phone: '',
        amount: '',
    });

    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };




    // Miniuteurs
    const [timeRemaining, setTimeRemaining] = useState(240); // 180 secondes (3 minutes)
    const [timerActive, setTimerActive] = useState(false);

    useEffect(() => {
        if (timerActive && timeRemaining > 0) {
            const timerInterval = setInterval(() => {
                setTimeRemaining((prevTime) => prevTime - 1);
            }, 1000);
            return () => clearInterval(timerInterval);
        } else if (timeRemaining === 0) {
            setTimerActive(false);
        }
    }, [timerActive, timeRemaining]);
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    const handleStartTimer = () => {
        setTimerActive(true);
    };

    const [paymentUrl, setPaymentUrl] = useState();
    const [IsLoginpaymentUrl, setIsLoginpaymentUrl] = useState(false);

    const handleGeneratePaymentUrl = async () => {
        try {
            setIsLoginpaymentUrl(true);
            const response = await axios.post(`${baseUrl.baseUrl}/api/v1/packs/generate-cinepay-payment-url`, {
                "amount": Number(formData.amount),
                "customer_id": ``,
                "customer_name": formData.firstname,
                "customer_surname": formData.lastname,
                "customer_email": "",
                "customer_phone_number": `${formData.countryCode}${formData.phone}`,
                "invoice_data": {
                    "UserID": "",
                    "PackID": "",
                    "TypePersonne": ""
                },
                "metadata": ""
            });

            if (response.status === 200) {
                setIsLoginpaymentUrl(false);
                setPaymentUrl(response?.data?.data?.payment_url);
                console.log(response?.data?.data?.payment_url);
                // Redirigez l'utilisateur vers l'URL de paiement
                // localStorage.setItem(localvalue.customer_transaction_id, response.data?.transactionId);
                window.open(response?.data?.data?.payment_url, '_blank');
                const transaction_id = response?.data?.transactionId;

                toast.success("Veillez effectuer le paiement ...");
                handleStartTimer();
                setTimeout(async () => {
                    let data = JSON.stringify({
                        "apikey": "35471582267581ffd8cf0d7.41868562",
                        "site_id": "5884028",
                        "transaction_id": String(transaction_id)
                    });

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: 'https://api-checkout.cinetpay.com/v2/payment/check',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };
                    // await axios.request(config)
                    //     .then(async (response) => {
                    //         if (response.data.code == "00") {
                    //             setIsLoginpaymentUrl(false)
                    //             await axios
                    //                 .post(`${baseurl.url}/api/v1/packs/${getAndCheckLocalStorage(localvalue.TYPEACCESS)}/${userId}/subscribe/${pack._id}`,
                    //                 )
                    //                 .then((response) => {
                    //                     confetti();
                    //                     toast.success("Votre Pack à été activer avec succès !");
                    //                     setTimeout(() => {
                    //                         window.location.href = `/`;
                    //                     }, 2500);
                    //                 })
                    //                 .catch((error) => {
                    //                     toast.error("Soucription pack échoué !");
                    //                 });

                    //         } else if (response.data.code == "627") {
                    //             setIsLoginpaymentUrl(false);
                    //             toast.error("Paiement non effectué Veillez Réesayer");
                    //             console.log(response.data);
                    //             window.location.reload()
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         setIsLoginpaymentUrl(false);
                    //         toast.error("Paiement imposible !")
                    //         console.log(error);
                    //         window.location.reload()
                    //     });
                }, 4 * 60 * 1000)
            }
        } catch (error) {
            setIsLoginpaymentUrl(false);
            // Gérer les erreurs ici
            toast.error("Tentative de paiement echoué veillez réessayer");
        }
    };











    const handleSubmit = (e) => {
        e.preventDefault();
        const amount = parseFloat(formData.amount);

        if (amount < 500 || amount > 1000000) {
            setMessage('Le montant doit être compris entre 500 et 1 000 000.');
            toast.error("Le montant doit être compris entre 500 et 1 000 000.")
        } else {

            handleGeneratePaymentUrl();
            setMessage('');
            // setFormData({ firstname: '', lastname: '', countryCode: '+225', phone: '', amount: '' });
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col justify-center items-center py-8">
            <div className="container mx-auto px-4 lg:px-16">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                    {/* Left Section: Payment Form */}
                    <div className="bg-white shadow-lg rounded-lg p-8">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 translatable">Informations de Paiement</h2>
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="firstname" className="block text-sm font-medium text-gray-700 translatable">Nom</label>
                                <input
                                    type="text"
                                    id="firstname"
                                    name="firstname"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 translatable"
                                />
                            </div>

                            <div>
                                <label htmlFor="lastname" className="block text-sm font-medium text-gray-700 translatable">Prénom</label>
                                <input
                                    type="text"
                                    id="lastname"
                                    name="lastname"
                                    value={formData.lastname}
                                    onChange={handleChange}
                                    required
                                    className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 translatable"
                                />
                            </div>

                            <div>
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 translatable">Numéro de téléphone</label>
                                <div className="flex space-x-2">
                                    <select
                                        name="countryCode"
                                        value={formData.countryCode}
                                        onChange={handleChange}
                                        className="block w-1/2 p-3 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500"
                                    >
                                        <option value="225">+225 (Côte d{"'"}Ivoire)</option>
                                        <option value="233">+233 (Ghana)</option>
                                        <option value="33">+33 (France)</option>
                                        <option value="234">+234 (Nigeria)</option>
                                        <option value="44">+44 (Royaume-Uni)</option>
                                        <option value="1">+1 (États-Unis)</option>
                                        <option value="49">+49 (Allemagne)</option>
                                        <option value="91">+91 (Inde)</option>
                                        <option value="81">+81 (Japon)</option>
                                        <option value="86">+86 (Chine)</option>
                                    </select>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        placeholder="Numéro"
                                        className="flex-grow block w-1/2 p-3 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 translatable"
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="amount" className="block text-sm font-medium text-gray-700 translatable">Montant (500 à 1 000 000)</label>
                                <input
                                    type="number"
                                    id="amount"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleChange}
                                    min="500"
                                    max="1000000"
                                    required
                                    className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 translatable"
                                />
                            </div>

                            {
                                IsLoginpaymentUrl
                                ?
                                <button
                                type="button"
                                className="w-full bg-green-600 text-white font-medium py-3 px-4 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                            >
                                <Spinner className=""/>
                            </button>
                            :
                            <button
                                type="submit"
                                className="w-full bg-green-600 text-white font-medium py-3 px-4 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 translatable"
                            >
                                Procéder au Paiement
                            </button>
                            }
                            
                        </form>

                        {message && (
                            <div className="mt-6 text-center text-sm text-red-600">{message}</div>
                        )}
                    </div>

                    {/* Right Section: Image and Message */}
                    <div className="bg-white text-center lg:text-left shadow-lg rounded-lg p-8">
                        <img src={imageDonation} alt="Faire un Don" className="rounded-lg shadow-md mb-6 mx-auto lg:mx-0" />
                        <h2 className="text-2xl font-bold text-gray-800 mb-4 translatable">Soutenez notre Église</h2>
                        <p className="text-gray-600 mb-4 translatable">
                            Votre générosité aide notre église à poursuivre ses activités et à impacter notre communauté. Chaque don compte ! Merci de tout cœur.
                        </p>
                        <p className="text-gray-500 translatable">
                            Disponible sur tous les appareils. Vous pouvez effectuer un don facilement depuis votre mobile, tablette ou ordinateur.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DonationCheckoutPage;
